import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-sm uppercase tracking-[0.2em] text-[#E65A28] mb-3 font-semibold">404</p>
        <h1 className="font-serif text-6xl text-[#0A192F]">Page not found</h1>
        <p className="mt-4 text-[#666]">Looks like this ritual doesn&apos;t exist yet.</p>
        <Link to="/" className="mt-8 inline-block bg-[#E65A28] text-white px-8 py-4 rounded-full font-semibold">Take me home</Link>
      </div>
    </div>
  );
}
